import {
  useQuery,
} from '@tanstack/react-query'
import { useAuth } from 'react-oidc-context';
import { IItem } from './types';

export function useItems(warehouseId?: string) {
  const auth = useAuth();

  const queryString = warehouseId ? `?warehouseId=${warehouseId}` : '';

  return useQuery({
    queryKey: ['items', warehouseId],
    queryFn: () =>
      fetch(`/api/items${queryString}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.user?.id_token}`,
        },
      }).then((res) =>
        res.json() as  Promise<{items:IItem[]}>,
      ),
    enabled: auth.isAuthenticated && auth.user?.id_token !== undefined
  });
}